/**
 * liveTickets.js — which ticketChecks docs are currently kept live (synced with
 * the server) by an open board's listener.
 *
 * useTicketChecks watches tickets in batched `documentId() in [...]` queries
 * rather than one listener per ticket. A per-ticket listener used to double as
 * the source for firestoreActions' "read the latest before writing" getDoc()
 * calls, which piggy-backed on it for free. A batched query doesn't serve that
 * doc-level getDoc — it would open its own listener, wait a server round trip
 * and bill a read on every tap. So the hook records here which tickets it is
 * keeping current, and firestoreActions reads those from the local cache, which
 * the live query keeps exactly as fresh as the old per-ticket listener did.
 *
 * Counted per listener, so two boards (KDS + pickup) watching the same ticket
 * don't un-mark each other.
 */
const live = new Map();   // ticketId → number of synced listeners covering it

/** A listener covering these ids has received a server-confirmed snapshot. */
export function markLive(ids) {
  ids.forEach((id) => live.set(id, (live.get(id) || 0) + 1));
}

/** That listener is gone (unsubscribed or errored). */
export function unmarkLive(ids) {
  ids.forEach((id) => {
    const n = (live.get(id) || 0) - 1;
    if (n > 0) live.set(id, n); else live.delete(id);
  });
}

export function isLiveTicket(id) {
  return (live.get(id) || 0) > 0;
}

/** Test helper. */
export function resetLiveTickets() {
  live.clear();
}
